export const time = {
  state: { startTime: null, endTime: null },
  reducers: {
    setStartTime(state, startTime) {
      return { ...state, startTime };
    },
    setEndTime(state, endTime) {
      return { ...state, endTime };
    },
  },
};
